import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { deployVersion } from '../../environments/environment';
import { Provider, EnvironmentProviders } from '@angular/core';

export function provideTranslate(): (Provider | EnvironmentProviders)[] {
  const translateModule = TranslateModule.forRoot({
    defaultLanguage: 'en',
    isolate: true,
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  });

  return translateModule.providers || [];
}

function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?version=${deployVersion}`);
}
